module.exports = __webpack_public_path__ + "static/media/banner_feygirl_sp.dc92a24b.png";